import { type OfferChannel, OfferNotificationTemplateChannel } from '@today/types'

/**
 * Step 4's warning predicate (TO-140 offer-notification-message REQ-109): the offer
 * links a template (`templateChannel` non-null) whose channel type is neither `ALL`
 * nor among the selected send channels.
 */
export function channelMismatch(
	templateChannel: OfferNotificationTemplateChannel | null,
	selected: readonly OfferChannel[],
): boolean {
	if (templateChannel === null || templateChannel === OfferNotificationTemplateChannel.ALL) return false
	// Nothing selected: Send is disabled anyway, so there is nothing to warn about yet.
	if (selected.length === 0) return false
	return !selected.some((channel) => String(channel) === String(templateChannel))
}
